import React from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../constants/aampeTheme';
// constants
import ICONS from '../../../constants/icons';

const LabelInfoDropdownSection = () => {
    return (
        <Container>
            <InfoTopContainer>
                <ICONS.helpCircle size={14} />
                <InfoText>Why keep only 10 Labels?</InfoText>
            </InfoTopContainer>
            <InfoBottomContainer>
                This provides a general idea. Learn more
            </InfoBottomContainer>
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: aampeTheme.colors.gray75,
    padding: aampeTheme.spacing(0.5, 0),
    marginTop: aampeTheme.spacing(1),
});

const InfoTopContainer = styled.div({
    display: 'flex',
    padding: aampeTheme.spacing(0.5, 1),
    alignItems: 'center',
});

const InfoText = styled.div({
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '19px',
    color: aampeTheme.colors.gray950,
    margin: aampeTheme.spacing(0, 1),
});

const InfoBottomContainer = styled.div({
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '19px',
    color: aampeTheme.colors.gray950,
    opacity: 0.5,
    padding: aampeTheme.spacing(0, 1),
});

export default LabelInfoDropdownSection;
